const cardActions = () => {
    const card = document.querySelector('[data-card-id]');

  

    if (!card) {
        return;
    }

    
    const oneClickOrderButton = card.querySelector('[data-snippet-oneclick]');
    const creditOrderButton = card.querySelector('[data-snippet-credit]');



    

    if (oneClickOrderButton) {
        const modal = document.querySelector('[data-oneclick-modal]');

        if (!modal) {
            return;
        }

        oneClickOrderButton.addEventListener('click', createOrderData.bind(null, card, modal));
    }

    if (creditOrderButton) {
        const modal = document.querySelector('[data-credit-modal]');

        if (!modal) {
            return;
        }

        creditOrderButton.addEventListener('click', createOrderData.bind(null, card, modal));
    }
}

const basketCardActions = () => {
    const oneClicksOrderButton = document.querySelector('[data-snippet-oneclicks]');

    if (oneClicksOrderButton) {
        const modal = document.querySelector('[data-oneclicks-modal]');

       /* if (!modal) {
            return;
        }*/

        oneClicksOrderButton.addEventListener('click', createOrderDatas.bind(null,  modal));
    }
} ;//cardActions;

const itemsSetActions = () => {
    const set = document.querySelector('[data-set]');

    if (!set) {
        return;
    }

    const setItems = set.querySelectorAll('[data-set-item]');
    const button = set.querySelector('[data-set-button]');

    const itemsData = Array.from(setItems).map((item) => {
        return {
            id: item.dataset.id,
            price: item.dataset.price,
        };
    });

    const callback = () => location.href = '/personal/cart/';

    button.addEventListener('click', () => {
        gateApi.addSetToCart({ items: itemsData, callback });
    });
};

basketCardActions();
cardActions();
itemsSetActions();
